<template>
  <div style="margin-top: 5px">
    <div
        class="search-input"
        style="margin-bottom: -20px; position: relative; z-index: 1"
    >
      <!-- input of detail -->
      <div v-if="visibleDetailDate">
        <el-date-picker
            class="input-common input-date"
            style="width: 135px"
            v-model="dataSearch.date"
            type="date"
            :clearable="false"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            placeholder="Chọn ngày"
            :picker-options="startDayOfWeek"
            @change="getSearchAllAttendanceDetail()"
        ></el-date-picker>

        <!-- chọn khối -->
        <el-select
            v-if="this.getAppTypeUserLogin === 'plus'"
            class="input-common input-grade"
            style="width: 140px"
            v-model="dataSearch.idGrade"
            @change="handleChangeGrade()"
            placeholder="Chọn khối"
        >
          <el-option
              v-for="item in gradeOfSchoolList"
              :key="item.id"
              :value="item.id"
              :label="item.gradeName"
          ></el-option>
        </el-select>

        <!-- chọn lớp -->
        <el-select
            class="input-common input-class"
            style="width: 140px"
            v-model="dataSearch.idClass"
            placeholder="Chọn lớp"
            @change="getSearchAllAttendanceDetail()"
        >
          <el-option
              v-for="item in classList"
              :key="item.id"
              :value="item.id"
              :label="item.className"
          ></el-option>
        </el-select>
      </div>

      <!-- search of attendance arrive -->
      <div v-else-if="visibleAttendanceArrive || visibleAttendanceEat">
        <el-date-picker
            class="input-common input-date"
            style="width: 135px"
            :clearable="false"
            v-model="dataSearch.date"
            type="date"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            placeholder="Chọn ngày"
            :picker-options="startDayOfWeek"
            @change="checkAbsentDateInClass('arrive')"
        ></el-date-picker>

        <!-- chọn khối -->
        <el-select
            v-if="this.getAppTypeUserLogin === 'plus'"
            class="input-common input-grade"
            style="width: 140px"
            v-model="dataSearch.idGrade"
            @change="changeGradeArrive()"
            placeholder="Chọn khối"
        >
          <el-option
              v-for="item in gradeOfSchoolList"
              :key="item.id"
              :value="item.id"
              :label="item.gradeName"
          ></el-option>
        </el-select>

        <!-- chọn lớp -->
        <el-select
            class="input-common input-class"
            style="width: 140px"
            v-model="dataSearch.idClass"
            placeholder="Chọn lớp"
            @change="checkAbsentDateInClass('arrive')"
        >
          <el-option
              v-for="item in classList"
              :key="item.id"
              :value="item.id"
              :label="item.className"
          ></el-option>
        </el-select>
      </div>
    </div>

    <!-- tab -->
    <div class="content-main">
      <div>
        <el-tabs type="card" @tab-click="handleClickTab" v-model="activeTabName">
          <!-- tab detail -->
          <el-tab-pane label="Chi tiết ngày" name="detailDate">
            <el-table
                ref="multipleTable"
                :empty-text="textTable"
                v-loading="loadingData"
                :element-loading-text="$tableLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255,255,255, 0)"
                :data="attendanceDetailDateList"
                :header-cell-style="tableHeaderColor"
                :max-height="$tableMaxHeight"
                border
            >
              <el-table-column type="selection" width="55" align="center"/>
              <el-table-column type="index" label="STT" width="50" align="center"/>
              <el-table-column prop="targetName" label="Họ tên" min-width="250"/>
              <el-table-column label="Lớp" min-width="200">
                <template>{{ this.dataSearch.className }}
                </template>
              </el-table-column>
              <!-- TỰ LẤY CA TỪ attendanceRecordList -->
              <el-table-column
                  v-for="session in sessionList"
                  :key="session.shiftId"
                  align="center"
              >
                <template #header>
                  <span
                      class="shift-title"
                      @click="detailShift(session.shiftId)"
                  >
                    {{ session.shiftName }}
                  </span>
                </template>
                <el-table-column label="Đi học" width="90" align="center">
                  <template #default="{ row }">
                    <i
                        v-if="getSession(row, session.shiftId).status === 'PRESENT'"
                        class="el-icon-circle-check"
                        style="color:#409eff;font-size:18px"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="Có phép" width="90" align="center">
                  <template #default="{ row }">
                    <i
                        v-if="getSession(row, session.shiftId).status === 'EXCUSED_ABSENT'"
                        class="el-icon-circle-close"
                        style="color:#f56c6c;font-size:18px"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="Không phép" width="95" align="center">
                  <template #default="{ row }">
                    <i
                        v-if="getSession(row, session.shiftId).status === 'UNEXCUSED_ABSENT'"
                        class="el-icon-error"
                        style="color:#f56c6c;font-size:18px"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="Giờ đến" width="90" align="center">
                  <template #default="{ row }">
                    <span>{{ getSession(row, session.shiftId).checkinTime | formatTime }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="Giờ về" width="90" align="center">
                  <template #default="{ row }">
                    <span>{{ getSession(row, session.shiftId).checkoutTime | formatTime }}</span>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column label="Tác vụ" fixed="right" width="100" align="center">
                <template v-slot:default="scope">
                  <el-button
                      size="mini"
                      type="success"
                      @click="handleShowDetailDate(scope.$index, scope.row)"
                  >{{ $t("button.view") }}
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-row type="flex">
              <el-col :span="20" style=" margin: 15px 0">
                <div class="container_nav_page">
                  <el-pagination
                      background
                      layout="prev, pager, next, sizes"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentPageChange"
                      :current-page.sync="dataSearch.page"
                      :page-sizes="listSizePage"
                      :total="total">
                  </el-pagination>
                </div>
              </el-col>
              <el-col :span="4">
                <!-- click xuất file -->
                <div style="float: right; margin: 15px 0">
                  <el-dropdown @command="handleCommand">
                    <el-button type="success" class="button-bottom">
                      {{ $t("button.exportFile") }}
                      <i class="el-icon-caret-bottom"/>
                    </el-button>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item command="exportDate">Xuất theo ngày</el-dropdown-item>
                        <el-dropdown-item command="exportMonth"
                        >Xuất theo tháng
                        </el-dropdown-item
                        >
                        <el-dropdown-item command="exportCustom">
                          Xuất file tổng hợp
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>

          <!-- tab attendance arrive -->
          <el-tab-pane
              label="Điểm danh"
              name="attendanceArriveTab"
          >
            <el-table
                ref="multipleTable"
                :empty-text="textTable"
                v-loading="loadingData"
                :element-loading-text="$tableLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255,255,255,0)"
                :data="attendanceArriveList"
                :header-cell-style="tableHeaderColor"
                @selection-change="handleSelectionChangeArrive"
                :max-height="$tableMaxHeight"
                border
            >
              <el-table-column type="selection" width="55" align="center"/>
              <el-table-column type="index" label="STT" width="50" align="center" fixed/>
              <el-table-column prop="targetName" label="Họ tên" min-width="250"/>
              <el-table-column label="Lớp" min-width="200">
                <template>{{ this.dataSearch.className }}
                </template>
              </el-table-column>

              <!-- TỰ SINH CỘT THEO CA -->
              <el-table-column
                  v-for="session in sessionList"
                  :key="session.shiftId"
                  align="center"
              >
                <template #header>
                  <span
                      class="shift-title"
                      @click="detailShift(session.shiftId)"
                  >
                    {{ session.shiftName }}
                  </span>
                </template>
                <!-- Đi học -->
                <el-table-column align="center" width="100">
                  <template #header>
                    <span class="second-title">Đi học</span><br/>
                    <el-checkbox
                        :ref="`headerGoSchool_${session.shiftId}`"
                        :checked="headerCheck.goSchool[session.shiftId]"
                        @change="toggleAll(session.shiftId,'goSchool', $event)"
                    />
                  </template>

                  <template #default="{ row }">
                    <el-checkbox
                        :disabled="getSession(row, session.shiftId).apply === false"
                        v-model="getSession(row, session.shiftId).goSchool"
                        @change="toggleRow(session.shiftId,'goSchool', row)"
                    />
                  </template>
                </el-table-column>

                <!-- Có phép -->
                <el-table-column align="center" width="100">
                  <template #header>
                    <span class="second-title">Có phép</span><br/>
                    <el-checkbox
                        :ref="`headerIsYes_${session.shiftId}`"
                        :checked="headerCheck.isYes[session.shiftId]"
                        @change="toggleAll(session.shiftId,'isYes', $event)"
                    />
                  </template>

                  <template #default="{ row }">
                    <el-checkbox
                        :disabled="getSession(row, session.shiftId).apply === false"
                        v-model="getSession(row, session.shiftId).isYes"
                        @change="toggleRow(session.shiftId,'isYes', row)"
                    />
                  </template>
                </el-table-column>

                <!-- Không phép -->
                <el-table-column align="center" width="100">
                  <template #header>
                    <span class="second-title">Không phép</span><br/>
                    <el-checkbox
                        :ref="`headerIsNo_${session.shiftId}`"
                        :checked="headerCheck.isNo[session.shiftId]"
                        @change="toggleAll(session.shiftId,'isNo', $event)"
                    />
                  </template>

                  <template #default="{ row }">
                    <el-checkbox
                        :disabled="getSession(row, session.shiftId).apply === false"
                        v-model="getSession(row, session.shiftId).isNo"
                        @change="toggleRow(session.shiftId,'isNo', row)"
                    />
                  </template>
                </el-table-column>

                <!-- Giờ đến -->
                <el-table-column label="Giờ đến" align="center" width="135">
                  <template #default="{ row }">
                    <el-time-picker
                        v-model="getSession(row, session.shiftId).checkinTime"
                        :disabled="!(getSession(row, session.shiftId).status === 'PRESENT')"
                        value-format="HH:mm"
                        format="HH:mm"
                        size="mini"
                        style="width:85%"
                        placeholder="Chọn"
                    />
                  </template>
                </el-table-column>

                <!-- Giờ về -->
                <el-table-column label="Giờ về" align="center" width="135">
                  <template #header>
                    <span class="second-title">Giờ về</span><br/>
                    <el-checkbox @change="toggleAll(session.shiftId,'timeLeaveAll', $event)"/>
                  </template>

                  <template #default="{ row }">
                    <el-time-picker
                        v-model="getSession(row, session.shiftId).checkoutTime"
                        :disabled="!(getSession(row, session.shiftId).status === 'PRESENT')"
                        value-format="HH:mm"
                        format="HH:mm"
                        size="mini"
                        style="width:85%"
                        placeholder="Chọn"
                    />
                  </template>
                </el-table-column>
              </el-table-column>

              <!-- Tác vụ -->
              <el-table-column
                  fixed="right"
                  label="Tác vụ"
                  width="200"
                  align="center"
              >
                <template #default="{ row, $index }">
                  <el-button size="mini" type="primary" @click="handleArriveRowSave($index, row)">
                    Lưu
                  </el-button>
                  <el-button size="mini" type="success" @click="handleArriveUpdateRowMethod($index, row)">
                    Sửa
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row type="flex">
              <el-col :span="19" style=" margin: 15px 0">
                <div class="container_nav_page">
                  <el-pagination
                      background
                      layout="prev, pager, next, sizes"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentPageChange"
                      :current-page.sync="dataSearch.page"
                      :page-sizes="listSizePage"
                      :total="total">
                  </el-pagination>
                </div>
              </el-col>
              <el-col :span="5">
                <!-- click xuất file -->
                <div style="float: right; margin: 15px 0">
                  <el-button
                      type="success"
                      class="button-bottom"
                      :loading="loadingButtonSaveArriveDate"
                      @click="handleArriveManyRowSave()"
                  >
                    <i class="el-icon-circle-check"/>
                    Lưu điểm danh
                  </el-button>
                  <el-dropdown @command="handleCommand">
                    <el-button type="success" class="button-bottom">
                      {{ $t("button.exportFile") }}
                      <i class="el-icon-caret-bottom"/>
                    </el-button>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item command="exportDate">Xuất theo ngày</el-dropdown-item>
                        <el-dropdown-item command="exportMonth"
                        >Xuất theo tháng
                        </el-dropdown-item
                        >
                        <el-dropdown-item command="exportCustom">
                          Xuất file tổng hợp
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <!-- tab attendance eat -->
          <el-tab-pane label="Điểm danh ăn" name="attendanceEat">
            <el-table
                ref="multipleTable"
                :empty-text="textTable"
                v-loading="loadingData"
                :element-loading-text="$tableLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255,255,255, 0)"
                :data="attendanceEatList"
                :header-cell-style="tableHeaderColor"
                @selection-change="handleSelectionChangeEat"
                :max-height="$tableMaxHeight"
                border
            >
              <el-table-column
                  type="selection"
                  align="center"
                  width="55"
              ></el-table-column>
              <el-table-column
                  type="index"
                  label="STT"
                  align="center"
                  width="50"
              ></el-table-column>
              <el-table-column
                  prop="userOtherResponse.fullName"
                  sortable
                  label="Họ tên"
                  min-width="160"
              ></el-table-column>
              <el-table-column
                  prop="infoOtherResponse.name"
                  label="Lớp"
                  min-width="130"
              ></el-table-column>
              <el-table-column
                  align="center"
                  width="80"
              >
                <template #header="scope">
                  Sáng
                  <br/>
                  <el-checkbox
                      @change="changeCheckboxAllEat('breakfast', scope.row)"
                      v-model="checkboxAllEatBreakfast"
                  ></el-checkbox>
                </template>
                <template v-slot:default="scope">
                  <el-checkbox
                      v-model="scope.row.attendanceEat.breakfast"
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                  align="center"
                  width="80"
              >
                <template #header="scope">
                  Phụ sáng
                  <br/>
                  <el-checkbox
                      @change="changeCheckboxAllEat('secondBreakfast', scope.row)"
                      v-model="checkboxAllEatSecondBreakfast"
                  ></el-checkbox>
                </template>
                <template v-slot:default="scope">
                  <el-checkbox
                      v-model="scope.row.attendanceEat.secondBreakfast"
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                  align="center"
                  width="60"
              >
                <template #header="scope">
                  Trưa
                  <br/>
                  <el-checkbox
                      @change="changeCheckboxAllEat('lunch', scope.row)"
                      v-model="checkboxAllEatLunch"
                  ></el-checkbox>
                </template>
                <template v-slot:default="scope">
                  <el-checkbox v-model="scope.row.attendanceEat.lunch"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                  align="center"
                  width="80"
              >
                <template #header="scope">
                  Chiều
                  <br/>
                  <el-checkbox
                      @change="changeCheckboxAllEat('afternoon', scope.row)"
                      v-model="checkboxAllEatAfternoon"
                  ></el-checkbox>
                </template>
                <template v-slot:default="scope">
                  <el-checkbox
                      v-model="scope.row.attendanceEat.afternoon"
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                  align="center"
                  width="80"
              >
                <template #header="scope">
                  Phụ chiều
                  <br/>
                  <el-checkbox
                      @change="changeCheckboxAllEat('secondAfternoon', scope.row)"
                      v-model="checkboxAllEatSecondAfternoon"
                  ></el-checkbox>
                </template>
                <template v-slot:default="scope">
                  <el-checkbox
                      v-model="scope.row.attendanceEat.secondAfternoon"
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                  align="center"
                  width="80"
              >
                <template #header="scope">
                  Tối
                  <br/>
                  <el-checkbox
                      @change="changeCheckboxAllEat('dinner', scope.row)"
                      v-model="checkboxAllEatDinner"
                  ></el-checkbox>
                </template>
                <template v-slot:default="scope">
                  <el-checkbox v-model="scope.row.attendanceEat.dinner"></el-checkbox>
                </template>
              </el-table-column>

              <el-table-column
                  v-if="checkPermission(['studentQuality_attendance_update'])"
                  label="Tác vụ"
                  width="180"
                  fixed="right"
                  align="center"
              >
                <template v-slot:default="scope">
                  <el-button
                      v-if="
                      scope.row.attendanceEat.breakfast &&
                      scope.row.attendanceEat.secondBreakfast &&
                      scope.row.attendanceEat.lunch &&
                      scope.row.attendanceEat.afternoon &&
                      scope.row.attendanceEat.secondAfternoon &&
                      scope.row.attendanceEat.dinner
                    "
                      size="mini"
                      type="primary"
                      style="width: 94px"
                      @click="handleEatRowUnCheckboxAll(scope.$index, scope.row)"
                  >Bỏ chọn
                  </el-button
                  >
                  <el-button
                      v-else
                      size="mini"
                      type="primary"
                      style="width: 94px"
                      @click="handleEatRowCheckboxAll(scope.$index, scope.row)"
                  >Chọn tất cả
                  </el-button
                  >
                  <el-button
                      size="mini"
                      type="success"
                      @click="handleEatRowSave(scope.$index, scope.row)"
                  >{{ $t("button.save") }}
                  </el-button
                  >

                </template>
              </el-table-column>
            </el-table>
            <el-row type="flex">
              <el-col :span="19" style=" margin: 15px 0">
                <div class="container_nav_page">
                  <el-pagination
                      background
                      layout="prev, pager, next, sizes"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentPageChange"
                      :current-page.sync="dataSearch.page"
                      :page-sizes="listSizePage"
                      :total="total">
                  </el-pagination>
                </div>
              </el-col>
              <el-col :span="5">
                <!-- click xuất file -->
                <div style="float: right; margin: 15px 0">
                  <el-button
                      v-if="checkPermission(['studentQuality_attendance_update'])"
                      type="success"
                      class="button-bottom"
                      :loading="loadingButtonSaveEatDate"
                      @click="handleEatManyRowSave()"
                  >
                    <i class="el-icon-circle-check"/>
                    Lưu điểm danh ăn
                  </el-button>
                  <el-dropdown @command="handleCommand">
                    <el-button type="success" class="button-bottom">
                      {{ $t("button.exportFile") }}
                      <i class="el-icon-caret-bottom"/>
                    </el-button>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item command="exportDate">Xuất theo ngày</el-dropdown-item>
                        <el-dropdown-item command="exportMonth"
                        >Xuất theo tháng
                        </el-dropdown-item
                        >
                        <el-dropdown-item command="exportCustom">
                          Xuất file tổng hợp
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </el-col>
            </el-row>

          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <AttendanceArriveUpdateV3
        :updateAttendance="updateAttendance"
        :dialogVisible="showDialogUpdateArrive"
        @dialog-close="closeDialogUpdateArriveMethod()"
        ref="AttendanceArriveUpdateV3"
    />
    <DetailShiftMasterDialog
        :isOpenDetailShiftMasterDialog="isOpenDetailShiftMasterDialog"
        :dataDetail="dataDetail"
        @dialog-close="closeDetailShiftMasterDialog"
    />
    <CreateAttendanceKidCustomExcelV3
        :teamType="teamType"
        :targetType="targetType"
        :dialogVisible="showDialogCreateAttendanceKidCustomExcel"
        @dialog-close="closeDialogAttendanceKidCustomExcel()"
        ref="CreateAttendanceKidCustomExcel"
    />
  </div>
</template>

<script>
import checkPermission from "@/utils/permission.js";
import moment from "moment";
import AttendanceService from "@/services/AttendanceService";
import {mapGetters, mapState} from "vuex";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import shiftMaster from "@/services/ShiftMaster";
import AttendanceArriveUpdateV3 from "@/views/attendance-v2/dialog/AttendanceArriveUpdateV3.vue";
import {exportAttendanceExcel} from "@/commonFuncion/exportAttendanceExcel"
import DetailShiftMasterDialog from "@/views/attendance-v2/dialog/DetailShiftMasterDialog.vue";
import {exportAttendanceMonthExcel} from "@/commonFuncion/exportAttendanceMonthExcel";
import CreateAttendanceKidCustomExcelV3 from "@/views/attendance-v2/dialog/CreateAttendanceKidCustomExcelV3.vue";

export default {
  components: {
    CreateAttendanceKidCustomExcelV3,
    DetailShiftMasterDialog,
    AttendanceArriveUpdateV3,
  },
  data() {
    return {
      dateStartEnd: "",
      loadingData: true,
      textTable: "",
      activeTabName: "detailDate",
      startDayOfWeek: {
        firstDayOfWeek: 1,
      },
      loadingButtonSaveArriveDate: false,
      loadingButtonSaveEatDate: false,
      visibleDetailDate: true,
      visibleAttendanceArrive: false,
      visibleAttendanceEat: false,
      multipleSelectionArrive: [],
      multipleSelectionEat: [],
      showDialogUpdateArrive: false,
      showDialogDetailEat: false,
      showDialogCreateAttendanceKidCustomExcel: false,
      attendanceArriveOneSave: {},
      attendanceArriveManySave: "",
      attendanceLeaveManySave: "",
      attendanceEatManySave: "",
      attendanceDetailDateList: [],
      attendanceArriveList: [],
      attendanceLeaveList: [],
      attendanceEatList: [],
      checkboxAllEatBreakfast: false,
      checkboxAllEatSecondBreakfast: false,
      checkboxAllEatLunch: false,
      checkboxAllEatAfternoon: false,
      checkboxAllEatSecondAfternoon: false,
      checkboxAllEatDinner: false,
      sessionList: [],
      headerCheck: {
        goSchool: {},
        isYes: {},
        isNo: {}
      },
      //end
      statusGoToSchoolList: [
        {value: true, label: "Đã điểm danh"},
        {value: false, label: "Chưa điểm danh"},
      ],
      dataSearch: {
        className: "",
        date: "",
        idGrade: "",
        idClass: "",
        absentStatus: "",
        limit: 50,
        page: 1,
      },
      total: 0,
      listSizePage: [50, 100, 150, 200, 300, 500],
      updateAttendance: false,
      dataDetail: {},
      isOpenDetailShiftMasterDialog: false,
      teamType: "CLASS",
      targetType: "STUDENT",

    };
  },
  created() {
    this.$store.dispatch('gradeModule/fetchDataGradeOfSchoolList');
    if (this.getAppTypeUserLogin === "plus") {
      this.$store.dispatch('classStore/fetchDataClassListCommon');
    } else {
      this.$store.dispatch('classStore/fetchDataClassInTeacher');
    }
  },

  computed: {
    ...mapState('gradeModule', ['gradeOfSchoolList']),
    ...mapGetters('classStore', ['classInTeacher']),
    ...mapState('classStore', ['classListCommon']),
    classList() {
      if (this.getAppTypeUserLogin === "plus") {
        return this.classListCommon.filter((x) => x.idGrade === this.dataSearch.idGrade)
      } else if (this.getAppTypeUserLogin === "teacher") {
        return this.classInTeacher;
      } else return this.classListCommon
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
  },

  watch: {
    gradeOfSchoolList: {
      immediate: true, // Kích hoạt ngay lập tức khi component được tạo
      handler(newVal) {
        if (newVal.length > 0) {
          this.getIdGrade();
        }
      },
    },
    classList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.getIdClass();
        }
      },
    },
  },
  methods: {
    getSession(row, shiftId) {
      return row.attendanceRecordList.find(s => s.shiftId === shiftId) || {};
    },
    checkPermission,
    handleChangeGrade() {
      if (this.getAppTypeUserLogin === "plus") {
        this.classList = this.classListCommon.filter((x) => x.idGrade === this.dataSearch.idGrade)
      } else if (this.getAppTypeUserLogin === "teacher") {
        this.classList = this.classInTeacher;
      } else {
        this.classList = this.classListCommon
      }
    },
    getIdGrade() {
      this.dataSearch.idGrade = this.gradeOfSchoolList[0].id;
    },
    getIdClass() {
      this.dataSearch.idClass = this.classList[0].id;
      this.getSearchAllAttendanceDetail()
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    handleCommand(command) {
      if (command === "exportDate") {
        this.exportExcelAttendanceDate();
      } else if (command === "exportMonth") {
        this.exportExcelAttendanceMonth();
      } else if (command === "exportCustom") {
        this.exportExcelAttendanceCustom();
      }
    },
    handleClickTab(tab) {
      let tabNameClick = tab.name;
      if (tabNameClick === "detailDate") {
        this.visibleDetailDate = true;
        this.visibleAttendanceArrive = false;
        this.visibleAttendanceEat = false;
        this.getSearchAllAttendanceDetail();
      } else if (tabNameClick === "attendanceArriveTab") {
        this.visibleDetailDate = false;
        this.visibleAttendanceArrive = true;
        this.visibleAttendanceEat = false;
        this.getSearchAllAttendanceDetail();
      }else if (tabNameClick === "attendanceEat") {
        this.visibleDetailDate = false;
        this.visibleAttendanceArrive = false;
        this.visibleAttendanceEat = true;
        this.checkboxAllEatBreakfast = false;
        this.checkboxAllEatSecondBreakfast = false;
        this.checkboxAllEatLunch = false;
        this.checkboxAllEatAfternoon = false;
        this.checkboxAllEatSecondAfternoon = false;
        this.checkboxAllEatDinner = false;
        this.getSearchAllAttendanceEat();
      }
    },
    /**
     * tìm kiếm điểm danh ăn cho các học sinh trong ngày
     */
    getSearchAllAttendanceEat() {
      this.loadingData = true;
      this.textTable = "";

      shiftMaster.searchEatDate(
          this.dataSearch.idClass,
          this.teamType,
          this.targetType,
          this.dataSearch.date,
          this.dataSearch.page,
          this.dataSearch.limit
      )
          .then((resp) => {
            this.attendanceEatList = resp.data.data.attendanceDateList;
          })
          .catch((err) => {
            console.log(err);
            this.attendanceEatList = [];
          })
          .finally(() => {
            if (this.attendanceEatList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });
    },
    exportExcelAttendanceDate() {
      this.$confirm("Bạn có chắc chắn muốn xuất file không?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(async () => {
        const resp = await shiftMaster.getDailyExel(
            this.dataSearch.idClass,
            this.teamType,
            this.targetType,
            this.dataSearch.date,
            "STUDYING",
            this.dataSearch.page,
            this.dataSearch.limit
        );
        await exportAttendanceExcel(resp.data.data, "STUDENT");
      });
    },

    exportExcelAttendanceMonth() {
      this.$confirm("Bạn có chắc chắn muốn xuất file không?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(async () => {
        const resp = await shiftMaster.getMonthlyExel(
            this.dataSearch.idClass,
            this.teamType,
            this.targetType,
            this.dataSearch.date,
            "STUDYING",
            this.dataSearch.page,
            this.dataSearch.limit
        );

        await exportAttendanceMonthExcel(resp.data.data, "STUDENT");
      });
    },

    // export attendance custom
    exportExcelAttendanceCustom() {
      this.showDialogCreateAttendanceKidCustomExcel = true;
    },

    closeDialogAttendanceKidCustomExcel() {
      this.showDialogCreateAttendanceKidCustomExcel = false;
      this.getSearchAllAttendanceEat();
    },

    handleShowDetailDate(index, row) {
      this.updateAttendance = false
      this.$refs.AttendanceArriveUpdateV3.getDataArriveRowInitial(this.dataSearch.idClass, this.dataSearch.date, row);
      this.showDialogUpdateArrive = true;
    },

    handleArriveUpdateRowMethod(index, row) {
      this.updateAttendance = true
      this.$refs.AttendanceArriveUpdateV3.getDataArriveRowInitial(this.dataSearch.idClass, this.dataSearch.date, row);
      this.showDialogUpdateArrive = true;
    },
    closeDialogUpdateArriveMethod() {
      this.showDialogUpdateArrive = false;
      this.getSearchAllAttendanceDetail();
    },
    handleSelectionChangeArrive(val) {
      this.multipleSelectionArrive = val;
    },

    handleSelectionChangeEat(val) {
      this.multipleSelectionEat = val;
    },
    /**
     * lưu một row cho điểm danh đến
     */
    handleArriveRowSave(index, row) {
      let data = []
      row.attendanceRecordList.forEach(item => {
        let object = {
          teamId: this.dataSearch.idClass,
          targetType: "STUDENT",
          targetId: item.targetId,
          shiftMasterId: item.shiftId,
          checkinTime: item.checkinTime,
          checkoutTime: item.checkoutTime,
          deviceId: item.deviceId,
          note: item.note,
          attendanceRecordDate: this.dataSearch.date,
          status: item.status,
        }
        data.push(object);
      })
      shiftMaster.saveAttendanceRecord(data)
          .then((resp) => {
            this.attendanceArriveOneSave = resp.data.data;
            NotifyMessage.leftCornerNotificationSuccess("Lưu điểm danh thành công")
            this.getSearchAllAttendanceDetail();
          })
          .catch((err) => {
            console.log(err);
            NotifyMessage.leftCornerNotificationError("Lưu điểm danh thất bại");
          });
    },
    /**
     * lưu nhiều row cho điểm danh đến
     */
    handleArriveManyRowSave() {
      let kidList = this.multipleSelectionArrive;
      if (kidList.length === 0) {
        NotifyMessage.leftCornerNotificationError("Không có học sinh nào được chọn")
        return;
      }
      let data = []
      kidList.forEach((x) => {
        x.attendanceRecordList.forEach(item => {
          let object = {
            teamId: this.dataSearch.idClass,
            targetType: "STUDENT",
            targetId: item.targetId,
            shiftMasterId: item.shiftId,
            checkinTime: item.checkinTime,
            checkoutTime: item.checkoutTime,
            deviceId: item.deviceId,
            note: item.note,
            attendanceRecordDate: this.dataSearch.date,
            status: item.status,
          }
          data.push(object);
        })
      });
      this.loadingButtonSaveArriveDate = true;
      this.$confirm(
          "Bạn có chắc chắn muốn lưu điểm danh cho " +
          kidList.length +
          " học sinh đã chọn?",
          "Lưu điểm danh",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      )
          .then(() => {
            shiftMaster.saveAttendanceRecord(data)
                .then((resp) => {
                  this.attendanceArriveManySave = resp.data.data;
                  NotifyMessage.leftCornerNotificationSuccess("Lưu điểm danh cho nhiều học sinh thành công")
                  this.getSearchAllAttendanceDetail();
                })
                .catch((err) => {
                  console.log(err);
                  NotifyMessage.leftCornerNotificationError("Lưu điểm danh cho nhiều học sinh thất bại")
                });
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingButtonSaveArriveDate = false;
            }, 500);
          });
    },

    /**
     * kiểm tra lớp đó trong ngày đó có đơn xin phép ngày chưa xác nhận hay không
     */
    checkAbsentDateInClass(type) {
      AttendanceService.checkAbsentDate(this.dataSearch.date, this.dataSearch.idClass)
          .then((resp) => {
            const data = resp.data.data;
            let absentList = data.dataList;

            const applicationForLeave = data.applicationForLeave;
            if (applicationForLeave) {
              if (absentList.length > 0) {
                this.$message({
                  message: "Bạn có " + absentList.length + " đơn xin nghỉ chưa được xác nhận",
                  type: "warning",
                  duration: 2500,
                });
              }
              this.getSearchAllAttendanceDetail()

            } else {
              if (absentList.length > 0) {
                if (type === "arrive") {
                  this.attendanceArriveList = [];
                } else if (type === "leave") {
                  this.attendanceLeaveList = [];
                }
                this.$alert(
                    "Bạn có " +
                    absentList.length +
                    " đơn xin nghỉ chưa được xác nhận, vui lòng xác nhận trước khi điểm danh",
                    "Thông báo!",
                    {
                      confirmButtonText: "Đã hiểu",
                    }
                );

              } else {
                this.getSearchAllAttendanceDetail()
              }
            }
          })
          .catch((err) => {
            this.attendanceArriveList = [];
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          });
    },

    /**
     * lấy danh sách tab chi tiết
     */
    async getSearchAllAttendanceDetail() {
      this.loadingData = true;
      this.textTable = "";

      const selected = this.classList.find(c => c.id === this.dataSearch.idClass);
      if (selected) {
        this.dataSearch.className = selected.className;
      } else {
        this.dataSearch.className = "";
      }

      try {
        const resp = await shiftMaster.searchAttendanceRecord(
            this.dataSearch.idClass,
            this.teamType,
            this.targetType,
            this.dataSearch.date,
            "STUDYING",
            this.dataSearch.page,
            this.dataSearch.limit
        );

        const content = resp.data.data.content;
        this.total = resp.data.data.totalElements;

        // === QUAN TRỌNG: Map status → boolean ===
        const processedList = content.map(student => {
          student.attendanceRecordList.forEach(session => {
            // Reset các boolean
            this.$set(session, 'goSchool', false);
            this.$set(session, 'isYes', false);
            this.$set(session, 'isNo', false);

            // Map theo status từ backend
            switch (session.status) {
              case 'PRESENT':
                this.$set(session, 'goSchool', true);
                break;
              case 'EXCUSED_ABSENT':
                this.$set(session, 'isYes', true);
                break;
              case 'UNEXCUSED_ABSENT':
                this.$set(session, 'isNo', true);
                break;
                // NOT_CHECKED_IN hoặc null → để false (mặc định)
            }
          });
          return student;
        });

        this.attendanceDetailDateList = processedList;
        this.attendanceArriveList = processedList;

        // Cập nhật sessionList và headerCheck
        if (processedList.length > 0) {
          this.sessionList = processedList[0].attendanceRecordList || [];

          this.sessionList.forEach(s => {
            this.$set(this.headerCheck.goSchool, s.shiftId, false);
            this.$set(this.headerCheck.isYes, s.shiftId, false);
            this.$set(this.headerCheck.isNo, s.shiftId, false);
          });

          // Cập nhật header check dựa trên dữ liệu thực tế
          this.sessionList.forEach(s => this.updateHeaderCheckFromData(s.shiftId));
        }
        this.getSearchAllAttendanceEat();
      } catch (err) {
        this.$message({
          message: err.response?.data?.message || "Lỗi tải dữ liệu",
          type: "error",
        });
        this.attendanceDetailDateList = [];
        this.attendanceArriveList = [];
        this.textTable = this.$tableEmpty;
      } finally {
        this.loadingData = false;
        if (this.attendanceArriveList.length === 0) {
          this.textTable = this.$tableEmpty;
        }
      }
    },
    updateHeaderCheckFromData(shiftId) {
      const list = this.attendanceArriveList;
      if (!list || list.length === 0) return;

      let countGo = 0;
      let countYes = 0;
      let countNo = 0;

      list.forEach(row => {
        const session = row.attendanceRecordList.find(s => s.shiftId === shiftId);
        if (session) {
          if (session.goSchool) countGo++;
          if (session.isYes) countYes++;
          if (session.isNo) countNo++;
        }
      });

      const total = list.length;

      this.$set(this.headerCheck.goSchool, shiftId, countGo === total);
      this.$set(this.headerCheck.isYes, shiftId, countYes === total);
      this.$set(this.headerCheck.isNo, shiftId, countNo === total);
    },
    handleSizeChange(value) {
      this.dataSearch.limit = value;
      this.getSearchAllAttendanceDetail();
    },
    handleCurrentPageChange(value) {
      this.dataSearch.page = value;
      this.getSearchAllAttendanceDetail();
    },
    toggleAll(shiftId, field, checked) {
      const list = this.attendanceArriveList || [];

      list.forEach(student => {
        const session = student.attendanceRecordList.find(s => s.shiftId === shiftId);
        if (!session) return;
        if (session.apply === true) {
          switch (field) {
            case "goSchool":
              session.goSchool = checked;
              if (checked) {
                session.status = "PRESENT";
                session.isYes = false;
                session.isNo = false;
                session.checkinTime = moment().format("HH:mm");
              } else {
                session.status = "NOT_CHECKED_IN";
                session.checkinTime = null;
                session.checkoutTime = null;
              }
              break;

            case "isYes":
              session.isYes = checked;
              if (checked) {
                session.status = "EXCUSED_ABSENT";
                session.goSchool = false;
                session.isNo = false;
                session.checkinTime = null;
                session.checkoutTime = null;
              } else if (!checked) {
                session.status = "NOT_CHECKED_IN";
              }
              break;

            case "isNo":
              session.isNo = checked;
              if (checked) {
                session.status = "UNEXCUSED_ABSENT";
                session.goSchool = false;
                session.isYes = false;
                session.checkinTime = null;
                session.checkoutTime = null;
              } else if (!checked) {
                session.status = "NOT_CHECKED_IN";
              }
              break;
            case "timeLeaveAll":
              if (checked && session.goSchool === true) {
                session.checkoutTime = moment().format("HH:mm");
              } else {
                session.checkoutTime = null;
              }
          }
        }

      });

      this.updateSessionHeader(shiftId);
    },


    toggleRow(shiftId, field, row) {
      const session = row.attendanceRecordList.find(s => s.shiftId === shiftId);
      if (!session) return;
      if (session.apply === true) {
        switch (field) {
          case "goSchool":
            if (session.goSchool) {
              session.status = "PRESENT";
              session.isYes = false;
              session.isNo = false;
              session.checkinTime = moment().format("HH:mm");
            } else {
              session.status = "NOT_CHECKED_IN";
              session.checkinTime = null;
              session.checkoutTime = null;
            }
            break;

          case "isYes":
            if (session.isYes) {
              session.status = "EXCUSED_ABSENT";
              session.goSchool = false;
              session.isNo = false;
              session.checkinTime = null;
              session.checkoutTime = null;
            } else {
              session.status = "NOT_CHECKED_IN";
            }
            break;

          case "isNo":
            if (session.isNo) {
              session.status = "UNEXCUSED_ABSENT";
              session.goSchool = false;
              session.isYes = false;
              session.checkinTime = null;
              session.checkoutTime = null;
            } else {
              session.status = "NOT_CHECKED_IN";
            }
            break;
        }
      }
      this.updateSessionHeader(shiftId);
    },

    updateSessionHeader(shiftId) {
      const list = this.attendanceArriveList || [];
      if (list.length === 0) {
        this.$set(this.headerCheck.goSchool, shiftId, false);
        this.$set(this.headerCheck.isYes, shiftId, false);
        this.$set(this.headerCheck.isNo, shiftId, false);
        return;
      }

      let countGo = 0;
      let countYes = 0;
      let countNo = 0;

      list.forEach(student => {
        const session = student.attendanceRecordList.find(s => s.shiftId === shiftId);
        if (!session) return;

        if (session.goSchool) countGo++;
        if (session.isYes) countYes++;
        if (session.isNo) countNo++;
      });

      const total = list.length;

      // Cập nhật header checkbox (checked + indeterminate)
      this.$set(this.headerCheck.goSchool, shiftId, countGo === total);
      this.$set(this.headerCheck.isYes, shiftId, countYes === total);
      this.$set(this.headerCheck.isNo, shiftId, countNo === total);

      // === Cập nhật indeterminate chính xác ===
      this.$nextTick(() => {
        // Header Đi học
        const goHeader = this.$refs[`headerGoSchool_${shiftId}`]?.$el?.querySelector('.el-checkbox__input');
        if (goHeader) {
          goHeader.classList.toggle('is-indeterminate', countGo > 0 && countGo < total);
        }

        // Header Có phép
        const yesHeader = this.$refs[`headerIsYes_${shiftId}`]?.$el?.querySelector('.el-checkbox__input');
        if (yesHeader) {
          yesHeader.classList.toggle('is-indeterminate', countYes > 0 && countYes < total);
        }

        // Header Không phép
        const noHeader = this.$refs[`headerIsNo_${shiftId}`]?.$el?.querySelector('.el-checkbox__input');
        if (noHeader) {
          noHeader.classList.toggle('is-indeterminate', countNo > 0 && countNo < total);
        }
      });
    },

    initHeaderChecks() {
      if (!this.attendanceArriveList || !this.attendanceArriveList.length) return;

      const sessions = this.attendanceArriveList[0].attendanceRecordList || [];
      sessions.forEach(s => {
        const name = s.shiftName;
        // khởi tạo reactive keys nếu chưa tồn tại
        if (!Object.prototype.hasOwnProperty.call(this.headerCheck.goSchool, name)) {
          this.$set(this.headerCheck.goSchool, name, false);
        }
        if (!Object.prototype.hasOwnProperty.call(this.headerCheck.isYes, name)) {
          this.$set(this.headerCheck.isYes, name, false);
        }
        if (!Object.prototype.hasOwnProperty.call(this.headerCheck.isNo, name)) {
          this.$set(this.headerCheck.isNo, name, false);
        }
        // cập nhật lần đầu để phản ánh trạng thái hiện tại của dữ liệu
        this.updateSessionHeader(name);
      });
    },


    getCurrentDate() {
      this.dataSearch.date = moment(String(new Date())).format("YYYY-MM-DD");
    },

    /**
     * đối khối cho tab arrive
     */
    async changeGradeArrive() {
      this.checkAbsentDateInClass("arrive");
    },

    detailShift(id) {
      shiftMaster.getShift(id).then(res => {
        this.dataDetail = res.data
        this.isOpenDetailShiftMasterDialog = true;
      }).catch(err => {
        console.log(err);
      })
    },
    closeDetailShiftMasterDialog() {
      this.isOpenDetailShiftMasterDialog = false;
    },
    /**
     * get data initial
     */
    async fetchDataMany() {
      this.getCurrentDate();
    },
    changeCheckboxAllEat(type) {
      this.attendanceEatList.forEach((x) => {
        switch (type) {
          case "breakfast": {
            x.attendanceEat.breakfast = this.checkboxAllEatBreakfast;
            break;
          }
          case "secondBreakfast": {
            x.attendanceEat.secondBreakfast = this.checkboxAllEatSecondBreakfast;
            break;
          }
          case "lunch": {
            x.attendanceEat.lunch = this.checkboxAllEatLunch;
            break;
          }
          case "afternoon": {
            x.attendanceEat.afternoon = this.checkboxAllEatAfternoon;
            break;
          }
          case "secondAfternoon": {
            x.attendanceEat.secondAfternoon = this.checkboxAllEatSecondAfternoon;
            break;
          }
          case "dinner": {
            x.attendanceEat.dinner = this.checkboxAllEatDinner;
            break;
          }
        }
      });
    },
    handleEatRowCheckboxAll(index, row) {
      row.attendanceEat.breakfast = true;
      row.attendanceEat.secondBreakfast = true;
      row.attendanceEat.lunch = true;
      row.attendanceEat.afternoon = true;
      row.attendanceEat.secondAfternoon = true;
      row.attendanceEat.dinner = true;
    },
    handleEatRowUnCheckboxAll(index, row) {
      row.attendanceEat.breakfast = false;
      row.attendanceEat.secondBreakfast = false;
      row.attendanceEat.lunch = false;
      row.attendanceEat.afternoon = false;
      row.attendanceEat.secondAfternoon = false;
      row.attendanceEat.dinner = false;
    },
    /**
     * lưu một row cho điểm danh ăn
     */
    handleEatRowSave(index, row) {
      let object = {
        id: row.attendanceEat.id,
        breakfast: row.attendanceEat.breakfast,
        secondBreakfast: row.attendanceEat.secondBreakfast,
        lunch: row.attendanceEat.lunch,
        afternoon: row.attendanceEat.afternoon,
        secondAfternoon: row.attendanceEat.secondAfternoon,
        dinner: row.attendanceEat.dinner,
        eatDate: this.dataSearch.date,
        targetId: row.userOtherResponse.id,
        targetType: "STUDENT"
      }
      let data = []
      data.push(object)
      shiftMaster.saveOrUpdateListAttendanceEat(data)
          .then((resp) => {
            console.log(resp.data.data)
            NotifyMessage.leftCornerNotificationSuccess("Lưu điểm danh ăn thành công")
            this.getSearchAllAttendanceEat();
          })
          .catch((err) => {
            console.log(err);
            NotifyMessage.leftCornerNotificationError("Lưu điểm danh ăn thất bại")
          });
    },
    /**
     * lưu nhiều row cho điểm danh ăn
     */
    handleEatManyRowSave() {
      let users = this.multipleSelectionEat;
      if (users.length === 0) {
        this.$message({
          message: "Không có học sinh nào được chọn",
          type: "error",
        });
        return;
      }
      this.loadingButtonSaveEatDate = true;
      this.$confirm(
          "Bạn có chắc chắn muốn lưu điểm danh ăn cho " +
          users.length +
          " học sinh đã chọn?",
          "Lưu điểm danh ăn",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      )
          .then(() => {
            let data = []
            for (let i = 0; i < users.length; i++) {
              let object = {
                id: users[i].attendanceEat.id,
                breakfast: users[i].attendanceEat.breakfast,
                secondBreakfast: users[i].attendanceEat.secondBreakfast,
                lunch: users[i].attendanceEat.lunch,
                afternoon: users[i].attendanceEat.afternoon,
                secondAfternoon: users[i].attendanceEat.secondAfternoon,
                dinner: users[i].attendanceEat.dinner,
                eatDate: this.dataSearch.date,
                targetId: users[i].userOtherResponse.id,
                targetType: "STUDENT"
              }
              data.push(object)
            }
            shiftMaster.saveOrUpdateListAttendanceEat(data)
                .then((resp) => {
                  console.log(resp.data.data)
                  NotifyMessage.leftCornerNotificationSuccess("Lưu điểm danh ăn thành công")
                  this.getSearchAllAttendanceEat();
                })
                .catch((err) => {
                  console.log(err);
                  NotifyMessage.leftCornerNotificationError("Lưu điểm danh ăn thất bại")
                });
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingButtonSaveEatDate = false;
            }, 500);
          });
    },

  },
  beforeMount() {
    this.fetchDataMany();
  }
  ,
}
;
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-icon-loading:before {
  content: "\e6cf";
}

/deep/ .el-loading-spinner .el-loading-text {
  color: #606266;
  font-size: 15px;
}

/deep/ .el-loading-spinner {
  top: 67%;
  width: 100%;
  text-align: center;
  position: absolute;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-tabs__nav-scroll {
  float: right;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #78a5e7;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

/deep/ .el-table th > .cell {
  text-align: center !important;
}

// /deep/.el-table td,
// /deep/.el-table th {
//   padding: 6px 0;
// }
/deep/ .el-table .cell {
  line-height: 15px;
}

/deep/ .el-table th > .cell {
  font-size: 13px;
}

/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}

.input-common {
  margin-right: 5px;
}

.button-bottom {
  border-radius: 0;
  margin-left: 3px;
}

.el-dropdown-menu {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 0;
  margin: 3px 0;
  background-color: #5fb44a;
  border: 1px solid #ebeef5;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 #0000001a;
}

.el-dropdown-menu li {
  color: white;
  border-top: 1px solid white;
  font-family: Arial, Helvetica, sans-serif;
}

//.second-title {
//  font-size: 10px;
//}

.absent-yes {
  color: #c82ee7;
}

.absent-no {
  color: #e61010;
}

.container_nav_page {
  display: flex;
  justify-content: center;
}

.shift-title {
  cursor: pointer;
  font-weight: 600;
}

.shift-title:hover {
  text-decoration: underline;
}

</style>
